import {Card, CardContent, Stack, Typography, Divider, IconButton, Box, CardActions} from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { humanize } from "./RecurrenceSelector";
import {shortenTime} from "../utils/dateUtils";

const ServiceRecurrenceCard = ({ recurrence, onEdit, onDelete }) => {
    return (
        <Card
            variant="outlined"
            sx={{
                maxWidth: 300,
                borderRadius: 2,
                boxShadow: 2,
                m: 1,
            }}
        >

            <CardContent>
                <Stack spacing={1}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Érvényesség kezdete:
                    </Typography>
                    <Typography variant="h6">{recurrence.recurrence.start_date}</Typography>

                    <Divider sx={{ my: 1 }} />

                    <Typography variant="subtitle2" color="text.secondary">
                        Ismétlődés
                    </Typography>
                    <Typography variant="body1">{humanize(recurrence.recurrence.data)}</Typography>

                    <Divider sx={{ my: 1 }} />

                    <Stack direction="row" justifyContent="space-between">
                        <div>
                            <Typography variant="subtitle2" color="text.secondary">
                                Kezdés
                            </Typography>
                            <Typography variant="body1">{shortenTime(recurrence.start)}</Typography>
                        </div>

                    </Stack>
                </Stack>
            </CardContent>
            <CardActions>
                {/* Action buttons */}
                <Box sx={{  display: "flex", gap: 1 }}>
                    <IconButton
                        onClick={onEdit}
                        sx={{
                            border: "2px solid",
                            borderColor: "primary.main",
                            background: "#fff",
                            color: "primary.main",
                            p: 0.5,
                        }}
                    >
                        <EditRoundedIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                        onClick={onDelete}
                        sx={{
                            border: "2px solid",
                            borderColor: "error.main",
                            background: "#fff",
                            color: "error.main",
                            p: 0.5,
                        }}
                    >
                        <DeleteRoundedIcon fontSize="small" />
                    </IconButton>
                </Box>
            </CardActions>
        </Card>
    );
};

export default ServiceRecurrenceCard;
